var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.84375,
    stroke: "#D7060F",
    strokeLinecap: "square"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.84375L6.5 6.5",
    stroke: "#D7060F",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.625C6.55254 8.625 6.60389 8.64058 6.64757 8.66977C6.69126 8.69895 6.7253 8.74044 6.74541 8.78897C6.76551 8.83751 6.77077 8.89092 6.76052 8.94245C6.75027 8.99397 6.72497 9.0413 6.68783 9.07845C6.65068 9.1156 6.60335 9.1409 6.55182 9.15115C6.5003 9.1614 6.44689 9.15613 6.39835 9.13603C6.34981 9.11593 6.30833 9.08188 6.27914 9.0382C6.24995 8.99452 6.23438 8.94316 6.23438 8.89062C6.23438 8.82018 6.26236 8.75261 6.31217 8.7028C6.36199 8.65299 6.42955 8.625 6.5 8.625Z",
    fill: "#00842F",
    stroke: "#D7060F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.96c00b82.svg";
export { ForwardRef as ReactComponent };